import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { IsActive } from './../../model';

@Component({
  selector: 'app-activate-checkbox',
  templateUrl: './activate.component.html'
})
export class ActivateCheckboxComponent implements OnInit {
  @Output() activateCheckboxStatus = new EventEmitter();
  @ViewChild('activated') private activatedCheckbox: ElementRef;
  @ViewChild('deactivated') private deactivatedCheckbox: ElementRef;

  applied: Boolean;
  status: number;

  activated: any;
  deactivated: any;
  isActivated: Boolean;
  isDeactivated: Boolean;

  constructor(
    private translate: TranslateService
  ) {
    this.translate.setDefaultLang('en-us');
  }

//  ngAfterViewInit() {
  ngOnInit() {
    this.activated = this.activatedCheckbox.nativeElement;
    this.deactivated = this.deactivatedCheckbox.nativeElement;

    this.isActivated = true;
    this.isDeactivated = false;

    this.applied = true;
    this.status = IsActive.active;

    this.emitStatus();
  }

  checkboxChange() {
    if (this.isActivated === this.activated.checked && this.isDeactivated === this.deactivated.checked) {
      this.applied = true;
    } else if ( this.activated.checked || this.deactivated.checked) {
      this.applied = false;
    } else {
      this.applied = true;
    }

    this.statusChange();
  }

  emitStatus() {
    this.activateCheckboxStatus.emit({
      activateCheckboxStatus: this.status,
      isApply: this.applied
    });
  }

  statusChange() {
    this.isActivated = this.activated.checked;
    this.isDeactivated = this.deactivated.checked;

    switch (true) {
      case this.activated.checked && this.deactivated.checked:
        this.status = IsActive.both;
        break;
      case this.activated.checked && !this.deactivated.checked:
        this.status = IsActive.active;
        break;
      case !this.activated.checked && this.deactivated.checked:
        this.status = IsActive.inactive;
        break;
      case !this.activated.checked && !this.deactivated.checked:
        this.status = IsActive.both;
        break;
      default:
        this.status = IsActive.active;
        break;
    }

    this.emitStatus();
  }
}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/shared/activate.component.ts